$(document).ready(function(){
      $('.main-img-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        fade:false,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 300,
        lazyLoad: 'ondemand',
        asNavFor: '.thumb-nav',
        prevArrow: '<div class="slick-prev"><i class="i-prev"></i><span class="sr-only sr-only-focusable">Previous</span></div>',
        nextArrow: '<div class="slick-next"><i class="i-next"></i><span class="sr-only sr-only-focusable">Next</span></div>'
      });
      // Thumbnail/alternates slider for product page
      $('.thumb-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: '0px',
        asNavFor: '.main-img-slider',
        dots: false,
        arrows: true,
        vertical: true,
        centerMode: false,
        draggable: true,
        speed:200,
        focusOnSelect: true,
        prevArrow: '<div class="slick-prev"><i class="i-prev"></i><span class="sr-only sr-only-focusable">Previous</span></div>',
        nextArrow: '<div class="slick-next"><i class="i-next"></i><span class="sr-only sr-only-focusable">Next</span></div>'  
      });

      $('.lesstion-posts-slider').slick({
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<div class="slick-arrow prev"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
        nextArrow: '<div class="slick-arrow next"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      }); 
      setTimeout(function(){  $(".lovedy-item").show(); }, 1000);
      setTimeout(function() {
        $('.lovedy-list').slick({
          dots: false,
          infinite: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,

              }
            }
          ]
        });
      }); 
      $('.build_your_own_section .products_listing_section .before_after_image_block .image_list.enable_slider').slick({
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 2000
      });
      $('.forbes-scn .forbes-list').slick({
        dots: false,
        arrows: true,
        infinite: true,
        arrows: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 2000,
        prevArrow: '<div class="slick-arrow prev"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
        nextArrow: '<div class="slick-arrow next"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',

      }); 
      $('.what-using-now-scn .what-using-now-list').slick({
        dots: true,
        infinite: true,
        arrows: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 2000,
        prevArrow: '<div class="slick-arrow prev"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
        nextArrow: '<div class="slick-arrow next"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',

      }); 


      $('span.video_close').on('click', function(){
        $('.popup_video').hide();
        $('span.play_icon').show();
      });
      $('span.play_icon').on('click', function(){
        $('.popup_video').show();
        setTimeout(function() {
          $('span.play_icon').hide();
        }, 1000);
      });


      setTimeout(function() {
        $('.home-products-carousel').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: true,
          prevArrow: '<div class="slick-arrow prev"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
          nextArrow: '<div class="slick-arrow next"><svg class="flickity-button-icon" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
          dots: false,
          responsive: [
            {
              breakpoint: 768,
              slidesToShow: 2,
              slidesToScroll: 2,
            },
            {
              breakpoint: 220,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        });

        $('.stacking-fix').slick({
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 1000,
          arrows: false,
          dots: true,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      }, 3000);
  
   $('.video_close').click(function(){
      //alert();
      $('.popup_video video').get(0).pause();
    });
  
  
  
   });